export enum SELLERS {
  AUCHAN = 'Auchan',
  ELECTRO_DEPOT = 'Electro Depot',
}
